<script lang="ts" setup>
import { computed } from 'vue';
import _ from 'lodash';
import { useCompanyStore } from '@Stores/company.store';

const PLACEHOLDER = '{{companyName}}';

const props = defineProps<{
    title?: string;
    icon?: string;
    moreInfo?: string;
}>();

const companyStore = useCompanyStore();

const companyName = computed(() => {
    const company = companyStore.company;
    return company?.dbaName || company?.name || '';
});

const resolvedMoreInfo = computed(() => {
    const text = props.moreInfo ?? '';
    return _.replace(text, new RegExp(_.escapeRegExp(PLACEHOLDER), 'g'), companyName.value);
});
</script>


<template>
    <div class="upcoming-step-tile">
        <div class="upcoming-step-tile__icon">
            <app-icon :icon="props.icon" class="upcoming-step-tile__icon-glyph" />
        </div>
        <div class="upcoming-step-tile__content">
            <div class="upcoming-step-tile__title">
                {{ props.title }}
            </div>
            <div class="upcoming-step-tile__more-info">
                {{ resolvedMoreInfo }}
            </div>
        </div>
    </div>

</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.upcoming-step-tile {
    display: flex;
    flex-flow: row nowrap;

    background-color: $gray-lightest;
    padding: 0.75rem;
    border-radius: 0.375rem;

    &__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 2.5rem;
        font-size: 2.5rem;
        margin-right: 1rem;

        .upcoming-step-tile__icon-glyph {
            color: $theme-primary;
        }
    }

    &__content {
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        font-size: 1rem;
        font-style: normal;
        line-height: 150%;
        color: var(--ch-primary-dark);
    }

    &__title {
        font-weight: 700;
        line-height: 150%;
    }
    &__more-info {
        font-weight: 400;
        line-height: 150%;
    }
}

</style>